import { Injectable } from '@angular/core'

const KEYS = {
  TOKEN: 'sinsc-candidato-token',
  EMAIL: 'sinsc-candidato-email',
  ID: 'sinsc-candidato-id',
  CPF: 'sinsc-candidato-cpf',
  REDIRECT_CONCURSO: 'sinsc_redirect_concurso_id',
  LANGUAGE: 'language',
} as const

@Injectable({ providedIn: 'root' })
export class StorageService {
  getToken(): string | null {
    return localStorage.getItem(KEYS.TOKEN)
  }
  setToken(token: string): void {
    localStorage.setItem(KEYS.TOKEN, token)
  }
  removeToken(): void {
    localStorage.removeItem(KEYS.TOKEN)
  }

  getEmail(): string | null {
    return localStorage.getItem(KEYS.EMAIL)
  }
  setEmail(email: string): void {
    localStorage.setItem(KEYS.EMAIL, email)
  }

  getId(): string | null {
    return localStorage.getItem(KEYS.ID)
  }
  setId(id: string): void {
    localStorage.setItem(KEYS.ID, id)
  }

  getLanguage(): string {
    return localStorage.getItem(KEYS.LANGUAGE) || 'pt'
  }
  setLanguage(lang: string): void {
    localStorage.setItem(KEYS.LANGUAGE, lang)
  }

  getRedirectConcursoId(): string | null {
    return localStorage.getItem(KEYS.REDIRECT_CONCURSO)
  }
  removeRedirectConcursoId(): void {
    localStorage.removeItem(KEYS.REDIRECT_CONCURSO)
  }

  set(key: string, value: string): void {
    localStorage.setItem(key, value)
  }

  clearSession(): void {
    localStorage.removeItem(KEYS.TOKEN)
    localStorage.removeItem(KEYS.EMAIL)
    localStorage.removeItem(KEYS.ID)
    sessionStorage.clear()
  }

  clearOnForbidden(): void {
    localStorage.removeItem(KEYS.TOKEN)
    localStorage.removeItem(KEYS.CPF)
    localStorage.removeItem(KEYS.EMAIL)
  }
}
